module.exports = __webpack_public_path__ + "7da8b15ff7f7b8b3c55f6f420ba40254.pdf";